import {Button, Modal} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../DanhSachKeHoach";
import {Formik, Form} from "formik";
import {CODE, TYPE_WH, WF_TRACKER} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import {OPTION_KHAO_SAT, TYPE_KE_HOACH_DAO_TAO, TYPE_KHAO_SAT} from "../constants/constansKeHoach";
import {
  addPhieuKhaoSat,  getTechTransferEquipment, getTechTransferInfrastructure,
  updatePhieuKhaoSat
} from "../services/services";
import TableDangKyDaoTao from "./TableDangKyDaoTao";
import DialogThemMoiDaoTao from "./DialogThemMoiDaoTao";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
}

const DialogBaoCaoKhaoSat = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues} = props;
  const {setIsLoading} = useContext(AppContext);
  const {detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(detailPhieuKeHoach?.isView);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [type, setType] = useState<TypeKeHoach | null>(TYPE_KHAO_SAT.BAO_CAO);
  const [dataTable, setDataTable] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [itemSelected, setItemSelected] = useState<any>();
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [typeDialogAddNew, setTypeDialogAddNew] = useState<any>(null);


  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      slipDto: {
        ...values.khaoSat,
        type: type?.type,
        doCreation: values?.khaoSat?.id ? formatDateDTO(values?.khaoSat?.doCreation) : formatDateDTO(new Date()),
      },
      ...dataTable,
      trackerCode: type?.trackerCode,
      termModelType: type?.formThongTinChung,
    };

    try {
      setIsLoading(true);
      const id = initialValues?.id;
      const {data} = id ? await updatePhieuKhaoSat(id, dataSubmit) : await addPhieuKhaoSat(dataSubmit);

      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        setDetailPhieuKeHoach({
          ...data?.data,
          statusId: detailPhieuKeHoach.statusId,
        });
        toast.success(((id) ? "Cập nhật" : "Thêm") + " phiếu thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSelectedRowsData = async (id: string) => {

      try {
        const dataSp = await getTechTransferInfrastructure(id);
        const dataProSp = await getTechTransferEquipment(id);

        setDataTable({
          [TYPE_KE_HOACH_DAO_TAO.CSHT.code]: dataSp?.data?.data ?? [],
          [TYPE_KE_HOACH_DAO_TAO.TRANG_THIET_BI.code]: dataProSp?.data?.data ?? [],
        })
      } catch (e) {

      }
  };

  useEffect(() => {
    initialValues?.id && getSelectedRowsData(initialValues?.id);
  }, []);
  useEffect(() => {
    updateForm();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({...generateInitValues(data), ...initialValues ?? {}});
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };
  const handleOpenDialogThemMoi = (type: any) => {
    setTypeDialogAddNew(type)
    setOpenDialogThemMoi(true);
  }

  const handleAddItem = async (values: any, source?: string) => {
    const key = typeDialogAddNew?.code;
    const item = values?.[key] || {};
    const list = dataTable?.[key] || [];

    const newList =
      indexRowEdit === null
        ? [{...item}, ...list]
        : list.map((x: any, i: number) => (i === indexRowEdit ? {...item} : x));

    if (source) {
      setDataTable((pre: any) => ({...pre, [key]: newList}));
    }
  };

  const handleEdit = (rowData: any, index: number, typeDialog: any) => {
    setTypeDialogAddNew(typeDialog)
    setItemSelected(rowData);
    setIndexRowEdit(index);
    setOpenDialogThemMoi(true)
  }

  const hanldeDeleteRow = (index: number, typeDelete: any) => {
    const key = typeDelete?.code;
    const list = dataTable?.[key] || [];

    const newList = list.filter((x: any, i: number) => i !== index);
    setDataTable((pre: any) => ({...pre, [key]: newList}));
  }

  const handleCloseDialog = () => {
    setItemSelected(null);
    setIndexRowEdit(null);
    setOpenDialogThemMoi(false);
    setTypeDialogAddNew(null)
  };

  const columnsCSHT = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(
      !isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                  <i
                      onClick={(e) => handleEdit(row, index, TYPE_KE_HOACH_DAO_TAO.CSHT)}
                      className="bi bi-pencil-square text-navy"
                  ></i>
                  <i
                      onClick={(e) => hanldeDeleteRow(index, TYPE_KE_HOACH_DAO_TAO.CSHT)}
                      className="bi bi-trash3-fill text-danger spaces ml-10  "
                  ></i>
              </>}
            </div>
        },
      ]
      : []
    ),

    {
      name: "Cơ sở hạ tầng",
      field: "infrastructureName",
      headerStyle: {
        // minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.infrastructureName || row.item?.infrastructureName || '',
    },
    {
      name: "Số lượng",
      field: "quanlity",
      headerStyle: {
        width: 180,
      },
      cellStyle: {
        textAlign: "right",
      },
      render: (row: any, index: number, stt: number) => row.quanlity || row.item?.quanlity || '',
    },
    {
      name: "Mức độ đáp ứng",
      field: "complianceLevelName",
      headerStyle: {
        width: 200,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => row?.complianceLevelName || row.item?.complianceLevelName || '',
    },
  ];

  const columnsTB = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(
      !isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                  <i
                      onClick={(e) => handleEdit(row, index, TYPE_KE_HOACH_DAO_TAO.TRANG_THIET_BI)}
                      className="bi bi-pencil-square text-navy"
                  ></i>
                  <i
                      onClick={(e) => hanldeDeleteRow(index, TYPE_KE_HOACH_DAO_TAO.TRANG_THIET_BI)}
                      className="bi bi-trash3-fill text-danger spaces ml-10  "
                  ></i>
              </>}
            </div>
        },
      ]
      : []
    ),

    {
      name: "Trang thiết bị",
      field: "equipmentName",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.equipmentName || row.item?.equipmentName || '',
    },
    {
      name: "Số lượng tốt",
      field: "goodConditionCount",
      headerStyle: {
        width: 120,
      },
      cellStyle: {
        textAlign: "right",
      },
      render: (row: any, index: number, stt: number) => row.goodConditionCount || row.item?.goodConditionCount || '',
    },
    {
      name: "Số lượng kém",
      field: "poorConditionCount",
      headerStyle: {
        width: 120,
      },
      cellStyle: {
        textAlign: "right",
      },
      render: (row: any, index: number, stt: number) => row.poorConditionCount || row.item?.poorConditionCount || '',
    },
    {
      name: "Số lượng không hoạt động",
      field: "outOfServiceCount",
      headerStyle: {
        width: 200,
      },
      cellStyle: {
        textAlign: "right",
      },
      render: (row: any, index: number, stt: number) => row.outOfServiceCount || row.item?.outOfServiceCount || '',
    },
    {
      name: "Đáp ứng nhu cầu sử dụng",
      field: "usageDemandName",
      headerStyle: {
        width: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row?.usageDemandName || row.item?.usageDemandName || '',
    },
  ];
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-phieu-khao-sat"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{khaoSat: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, 'khaoSat')}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Báo cáo khảo sát`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView={isView}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    setFieldValue={setFieldValue}
                    modelID={'khaoSat'}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                  />
                  <hr/>
                  <TableDangKyDaoTao
                    title={"Cơ sở hạ tầng"}
                    columns={columnsCSHT}
                    isView={isView}
                    shouldNotShowActionTop={isView}
                    setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                    setOpenDialog={handleOpenDialogThemMoi}
                    dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.CSHT.code] ?? []}
                    type={TYPE_KE_HOACH_DAO_TAO.CSHT}
                  />
                  <TableDangKyDaoTao
                    columns={columnsTB}
                    title={"Trang thiết bị"}
                    isView={isView}
                    shouldNotShowActionTop={isView}
                    setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                    setOpenDialog={handleOpenDialogThemMoi}
                    dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.TRANG_THIET_BI.code] ?? []}
                    type={TYPE_KE_HOACH_DAO_TAO.TRANG_THIET_BI}
                  />
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {type?.formThongTinChung && !isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
                {(values.khaoSat?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && type?.trackerCode && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...data,
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                      if (data?.currCode === "survey_report" && !data?.firstTime && type?.trackerCode === WF_TRACKER.SURVEY_TECHNIQUE_TRANFER) {
                        toast.success('Thành công')
                        onHide()
                      }
                    }}
                    handleClick={(data: any) => {
                      data.code === "allowed-edit" && setIsView(false);
                    }}
                    tracker={type?.trackerCode}
                    objectId={values.khaoSat?.id || detailPhieuKeHoach?.id}
                  />
                )}
              </div>
            </Form>
          </>
        )}
      </Formik>


      {openDialogThemMoi && typeDialogAddNew &&
          <DialogThemMoiDaoTao
              onOk={handleAddItem}
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={{
                [typeDialogAddNew.code]: {
                  ...itemSelected,
                  id: indexRowEdit === null ? null : Math.random().toString(36).substring(0, 10),
                }
              }}
              type={typeDialogAddNew}
          />
      }
    </Modal>
  );
};

export default DialogBaoCaoKhaoSat;
